import { color, spacing } from '@gyym/ui'
import styled from 'styled-components'

import { SpacingType } from '@/hooks/useSpacingProps'

import { Heading as TopHeading } from './Heading'

export type BackgroundType = 'default' | 'alt'

export const Heading = styled(TopHeading)``

export const Content = styled.div``

interface ContainerProps {
  backgroundType: BackgroundType
  padding: SpacingType
  margin: SpacingType
  gap?: number
}

export const Container = styled.section<ContainerProps>`
  display: flex;
  flex-direction: column;
  gap: ${({ gap = 6 }) => spacing(gap)};
  background-color: ${({ backgroundType }) =>
    color(backgroundType === 'default' ? 'white' : 'offWhite')};

  padding: ${({ padding }) => spacing(...padding)};
  margin: ${({ margin }) => spacing(...margin)};
`
